module.exports = __webpack_public_path__ + "static/media/logo-white-text.d0c47fe9.png";